import {ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter, withComponentInputBinding, withInMemoryScrolling} from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpInterceptorService } from '../shared/services/interceptors/http-interceptor/http-interceptor.service';
import { SECURE_STORAGE_CONFIG, StorageConfig } from 'ngx-secure-storage';
import { environment } from '../environments/environment';
import { Store } from '../utils/stores';
import {ApiModule} from '../sdk/bor-api';
import {provideNgxSkeletonLoader} from 'ngx-skeleton-loader';
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })), provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true
    },
    {
      provide: SECURE_STORAGE_CONFIG, useValue: {
        encryptionKey: environment.localStoreEncryptionKey,
        prefix: '_STR_',
        alwaysUseSessionStorageSet: [Store.PAYMENT_INFO_STORE],
        disableInDev: true
      } as StorageConfig
    },
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        height: '20px',
      },
    }),
    importProvidersFrom(ApiModule.forRoot({rootUrl: environment.apiBaseURL})),
    importProvidersFrom(RecaptchaV3Module),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
  ]
};
